import { useState } from 'react';
import '@/App.css';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Identity from '@/components/Identity';
import Sound, { works } from '@/components/Sound';
import Journey from '@/components/Journey';
import Sonic from '@/components/Sonic';
import EpkEssentials from '@/components/EpkEssentials';
import Contact from '@/components/Contact';
import NowPlaying from '@/components/NowPlaying';

function App() {
  const [nowPlaying, setNowPlaying] = useState(null);

  const handleTrackChange = (trackIndex) => {
    setNowPlaying((prev) => (prev ? { ...prev, trackIndex } : null));
  };

  return (
    <div className={`epk${nowPlaying ? ' epk--playing' : ''}`} data-testid="epk-app">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <Hero />
      <Identity />
      <Sound nowPlaying={nowPlaying} onPlay={setNowPlaying} />
      <Journey />
      <Sonic />
      <EpkEssentials />
      <Contact />
      {nowPlaying && (
        <NowPlaying
          work={works[nowPlaying.workIndex]}
          trackIndex={nowPlaying.trackIndex}
          onTrackChange={handleTrackChange}
          onClose={() => setNowPlaying(null)}
        />
      )}
    </div>
  );
}

export default App;
